var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"overflow-hidden mt-5"},[_c('b-row',{staticClass:"mt-5"},[_c('b-col',{staticClass:"mt-3",attrs:{"cols":"12"}},[_c('b-skeleton-img',{attrs:{"no-aspect":"","height":"550px"}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }